<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Landing Rates</h1>
        <div class="pull-right">
          <button
            class="pointer btn btn-lg btn-primary"
            v-on:click="form.showEdit({})"
          >
            Create New
          </button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Date</th>
                <th>Site</th>
                <th>Inspector</th>
                <th>Municipality</th>
                <th>Zone</th>
                <th>Mosquitoes</th>
                <th>Weather</th>
                <th>Work Status</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.list">
                <td>
                  {{ item.attributes.observedDate | date }}
                  {{ item.attributes.observedTime | time }}
                </td>
                <td>{{ siteName(item.attributes.siteId) }}</td>
                <td>{{ applicatorName(item.attributes.inspectorId) }}</td>
                <td>{{ municipalityName(item.attributes.municipalityId) }}</td>
                <td>{{ zoneName(item.attributes.zoneId) }}</td>
                <td>
                  <ul>
                    <li
                      v-for="mosquito in item.attributes.landingRateMosquitoes"
                    >
                      {{
                        mosquito.mosquitoSpecyId
                          ? mosquitoName(mosquito.mosquitoSpecyId)
                          : '?'
                      }}
                      ({{ mosquito.mosquitoCount }})
                    </li>
                  </ul>
                </td>
                <td>{{ item.attributes.weather }}</td>
                <td>{{ item.attributes.workStatus }}</td>

                <td>
                  <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                  <router-link
                    :to="{
                      name: 'data-landing-rate-details',
                      params: { id: item.id },
                    }"
                    ><i class="fa fa-ellipsis-h mr-10" title="Add Data"></i
                  ></router-link>
                  <a
                    class="pointer text-danger"
                    v-on:click="form.destroy(item.id)"
                    ><i class="fa fa-times" title="Delete"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
  </div>
</template>

<script>
import LandingRatesService from '@/services/LandingRatesService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/landing_rate';
import pager from '@/components/forms/pager';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';

import store from '@/store';

export default {
  name: 'no_spray',

  props: ['type', 'id'],

  components: {
    pager,
    siteForm,
    searchFields,
    loading,
  },

  data() {
    return {
      searchFieldsList: { site: 'Name', zone: 'Zone', address: 'Address' },
      form: new Form(LandingRatesService, {
        workStatus: 'Closed by office',
      }),
    };
  },

  methods: {
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    mosquitoName(id) {
      return this.$store.getters.mosquitoNameById(id);
    },
    applicatorName(id) {
      return this.$store.getters.applicatorNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
  },

  created() {
    if (this.$props.id == 'new') {
      window.bus.$on('item-created', () => {
        if (this.$route.path.indexOf('landing-rates') > -1) {
          setTimeout(() => {
            this.form.showEdit({});
          }, 1000);
        }
      });
    }
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });

    if (this.$props.id) {
      this.form.showEdit({});
      this.form.siteSearch.term = this.siteName(this.$props.id);
      this.form.onSiteSearch('siteId');
    }
  },
};
</script>

<style lang="scss"></style>
